import { SuspensionStatus } from "../enums/global.enums";

export function suspensionStatusPipe(value: string) {
    switch (value) {
        case SuspensionStatus.Active: return "Hiệu lực";
        case SuspensionStatus.Disabled: return "Không hiệu lực";
    }
    return "";
}

export const SUSPENSION_STATUSES = [
    SuspensionStatus.Active,
    SuspensionStatus.Disabled,
]